const Info = ({ fill = '#36C', width = '18', height = '18' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z"
                stroke="#1A1A1A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M8 10.6667V8" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 5.3335H8.00667" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default Info
